export default __webpack_public_path__ + "static/media/flag-liberia.cdf37184.svg";